import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/火爆.png';
const _hoisted_1 = {
  class: "MaterialCardContainer opd16 box"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "hot-img"
};
const _hoisted_3 = {
  class: "brd6 wd100 box leftCenter",
  style: {
    "padding": "10px",
    "box-shadow": "0px 4px 10px 0px rgba(0, 0, 0, 0.3)"
  }
};
const _hoisted_4 = {
  class: "cardRight box",
  style: {
    "height": "225px",
    "width": "150px"
  }
};
const _hoisted_5 = {
  class: "boldFont ft15"
};
const _hoisted_6 = {
  class: "info-content",
  style: {
    "color": "gray",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_7 = {
  class: "cardBelow"
};
const _hoisted_8 = {
  class: "left-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_text = _resolveComponent("el-text");
  const _component_el_row = _resolveComponent("el-row");
  const _component_Download = _resolveComponent("Download");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_EditPen = _resolveComponent("EditPen");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.data.boom ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "cardLeft picture",
    style: _normalizeStyle(`background-image:url(${$options.coverImg})`),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.toDetail && $options.toDetail(...args))
  }, null, 4), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "cardTop ptr",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toDetail && $options.toDetail(...args))
  }, [_createElementVNode("span", _hoisted_5, _toDisplayString($props.data.title), 1), _createElementVNode("span", _hoisted_6, _toDisplayString($options.extractPlainText($props.data.content)), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
    class: "bothCenter ft12",
    style: {
      "padding": "6px 0"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 16
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.data.createdTime.substring(0, 10)), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_text, {
        truncated: "",
        style: {
          "font-size": "12px",
          "color": "black",
          "line-height": "12px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($props.data.creatorName), 1)]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "ft12"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.tags.slice(0, 8), (tag, tagi) => {
      return _openBlock(), _createElementBlock("span", {
        key: `tag_${tagi}`,
        class: "brd6 tags",
        style: _normalizeStyle('color:' + $data.tagColors[tagi % $data.tagColors.length] + ';border:1px solid ' + $data.tagColors[tagi % $data.tagColors.length] + ';')
      }, _toDisplayString(tag), 5);
    }), 128))]),
    _: 1
  }), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
    size: "small",
    plain: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "ptr",
      onClick: $options.download
    }, {
      default: _withCtx(() => [_createVNode(_component_Download)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_el_button, {
    size: "small",
    plain: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "ptr",
      onClick: $options.copy
    }, {
      default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), $props.data.owner ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    size: "small",
    plain: "",
    type: "primary"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "ptr",
      onClick: $options.toEdit
    }, {
      default: _withCtx(() => [_createVNode(_component_EditPen)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true)])])])])]);
}